export enum YgdRoutes {
    Profile = '/profile',
    Tasks = '/tasks',
    History = '/history',
    Balance = '/balance',
}
